var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer-box"},[_c('img',{staticClass:"footer-logo",attrs:{"src":require("../../assets/img/index/logo_white.png"),"alt":""}}),_vm._v(" "),_c('span',[_vm._v("深圳货拉拉科技有限公司")]),_vm._v(" "),_c('span',{staticClass:"footer-space"},[_vm._v("|")]),_vm._v(" "),_c('span',[_vm._v("粤ICP备14091972号")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-886d17be","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/e-footer.vue
// module id = 683
// module chunks = 0